import { render, staticRenderFns } from "./Conteggi.vue?vue&type=template&id=601f21de&"
import script from "./Conteggi.vue?vue&type=script&lang=js&"
export * from "./Conteggi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports